export class StringUtils {
  public static isString(value: any): value is string {
    return typeof value === 'string';
  }

  public static lowerFirst(value: string): string {
    return value.charAt(0).toLowerCase() + value.slice(1);
  }
}
